import PropTypes from "prop-types";
import { Navigate } from "react-router-dom";
import useAuth from "../hooks/useAuth";
import handlePermission from "../utils/handlePerm";

PermGuard.propTypes = {
  perm: PropTypes.string,
  children: PropTypes.node,
};

export default function PermGuard({ perm, children }) {
  const { user } = useAuth();
  const permissions = user?.user_permissions_list || [];

  if (perm && !handlePermission(permissions, perm)) {
    return <Navigate to="/404" replace />;
  }

  return <>{children}</>;
}
